export enum TransferSetState {
  FINALIZED = 'finalized',
  PENDING = 'pending',
  TRANSFERRING = 'transferring',
  TRANSFERRING_TO_CHECKING = 'transferring_to_checking',
  TRANSFERRING_TO_SAVINGS = 'transferring_to_savings',
}
